<template lang="html">
  <div>
    <h1>Register user</h1>
    <hr />
    <v-layout>
      <v-text-field solo label="Name" v-model="user.name"></v-text-field>
    </v-layout>
    <v-layout>
      <v-text-field solo label="Surname" v-model="user.surname"></v-text-field>
    </v-layout>
    <v-layout>
      <v-text-field solo label="Email" v-model="user.email"></v-text-field>
    </v-layout>
    <v-layout v-if="emailError">
      <label style="margin-top: -22px;margin-bottom: 7px;">{{ emailMsg }}</label>
    </v-layout>
    <v-layout>
      <vue-tel-input style="max-height: 48px; margin-bottom: 30px;" tabindex="0" class="vue-tel-input" id="phone-input" v-model="user.phone" v-bind="bindProps" @validate="validPhone" @input="clearValidation" @open="onDropdownOpen(true)"
@close="onDropdownOpen(false)"> 
        <template v-slot:arrow-icon>
  <span>{{ open ? '' : '' }}</span>
</template></vue-tel-input>
          <div class="phone-alert" v-if="phoneError && user.phone != ''">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w 3.org/1999/xlink" width="14px" height="14px"
          viewBox="0 0 14 14" version="1.1">
          <g id="surface1">
            <path style="
                  stroke: none;
                  fill-rule: nonzero;
                  fill: rgb(84.313725%, 15.686275%, 15.686275%);
                  fill-opacity: 1;
                "
              d="M 14 7 C 14 10.867188 10.867188 14 7 14 C 3.132812 14 0 10.867188 0 7 C 0 3.132812 3.132812 0 7 0 C 10.867188 0 14 3.132812 14 7 Z M 14 7 " />
            <path style="
                  stroke: none;
                  fill-rule: nonzero;
                  fill: rgb(90.196078%, 90.196078%, 90.196078%);
                  fill-opacity: 1;
                "
              d="M 6.34375 10.9375 L 7.65625 10.9375 L 7.65625 9.625 L 6.34375 9.625 Z M 6.34375 2.625 L 6.34375 8.3125 L 7.65625 8.3125 L 7.65625 2.625 Z M 6.34375 2.625 " />
          </g>
        </svg>
        <span>{{
          phoneErrorMsg
        }}</span>
      </div>
    </v-layout>
    <v-layout>
      <v-text-field solo label="Password" v-model="user.password" @change="changePassword"></v-text-field>
    </v-layout>
    <v-layout>
      <v-text-field solo label="Coupon" v-model="user.code.text"></v-text-field>
      <svg style="width: 55px; height: 55px;" v-if="!couponError && user.code.text != ''" id="Layer_1" version="1.1"
        viewBox="0 0 612 792" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <g>
          <path fill="green" class="st0"
            d="M562,396c0-141.4-114.6-256-256-256S50,254.6,50,396s114.6,256,256,256S562,537.4,562,396L562,396z    M501.7,296.3l-241,241l0,0l-17.2,17.2L110.3,421.3l58.8-58.8l74.5,74.5l199.4-199.4L501.7,296.3L501.7,296.3z" />
        </g>
      </svg>
      <svg style="width: 50px; height: 50px;" v-else-if="couponError && (user.code.text != '' || user.code.text != null)"
        version="1.1" viewBox="0 0 36 36" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Layer_1" />
        <g id="icons">
          <path fill="red" class="st0"
            d="M6.2,3.5L3.5,6.2c-0.7,0.7-0.7,1.9,0,2.7l9.2,9.2l-9.2,9.2c-0.7,0.7-0.7,1.9,0,2.7l2.6,2.6   c0.7,0.7,1.9,0.7,2.7,0l9.2-9.2l9.2,9.2c0.7,0.7,1.9,0.7,2.7,0l2.6-2.6c0.7-0.7,0.7-1.9,0-2.7L23.3,18l9.2-9.2   c0.7-0.7,0.7-1.9,0-2.7l-2.6-2.6c-0.7-0.7-1.9-0.7-2.7,0L18,12.7L8.8,3.5C8.1,2.8,6.9,2.8,6.2,3.5z"
            id="close_1_" />
        </g>
      </svg>
    </v-layout>
    <v-layout>
      <v-text-field style="margin: 0px 5px;" solo label="Class letter"
        v-model="user.promocode.selected.letter"></v-text-field>
      <v-text-field style="margin: 0px 5px;" solo label="Class number"
        v-model="user.promocode.selected.number"></v-text-field>
    </v-layout>

    <v-layout row align-start class="pt-4" style="margin-bottom: 20px;margin-left: 0px;">
      <v-btn :disabled="emailVerified && phoneVerified ?false:true" color="success" @click="register">Register</v-btn>
    </v-layout>
  </div>
</template>
  
<script>
import CryptoJS from "crypto-js";
import { Base64 } from 'js-base64';
import icons from "./icons.store";
export default {
  name: "playlist",
  data() {
    return {
      couponError: false,
      user: {
        name: "",
        surname: "",
        email: "",
        phone:"",
        password: "",
        passwordConfirm: "",
        facebook_id: "",
        google_id: "",
        apple_id: "",
        users: {
          secondUser: false,
          thirdUser: false,
        },
        code: {
          text: "",
          status: false,
          checked: false,
        },
        question: {
          options: ["אף פעם ", "יש כזו גלידה? ", " מה זה קשור להרשמה??"],
          selected: "",
        },
        promocode: {
          selected: {
            letter: "",
            number: "",
          },
          title: {
            position: "",
            city: "",
            school: "",
          },
        },
      },
      open:false,
      timer: null,
      emailError: false,
      emailMsg: "",
      timerEmail: null,
      emailVerified: false,
      phoneError: null,
      phoneVerified: false,
      loadinSocial: false,
      phoneErrorMsg: "",
      bindProps: {
        autoFormat: true,
        autoDefaultCountry: false,
        defaultCountry: "IL",
        validCharactersOnly: true,
        mode: "international",
        disabled: false,
        preferredCountries: ["IL", "US", "UA"],
        dropdownOptions: {
          showDialCodeInList: true,
          showFlags: true,
          width: "250px",
        },
        inputOptions: {
          showDialCode: true,
          autocomplete: "off",
          placeholder: "הזן מספר טלפון",
          required: true,
          type: "tel",
          name: "phone",
          maxLen: 25,
        },
      },
    }
  },
  watch: {
    "user.code.text": {
      handler(val, oldVal) {
        this.checkCoupon();
      },
    },
    "user.email": {
      handler(val, oldVal) {
        this.validateEmail();
      },
    }
  },
  methods: {
    onDropdownOpen(val)
    {
      this.open = val;
    },
    validPhone(event) {
      this.phoneError = false;
      this.phoneErrorMsg = "";
      this.phoneVerified = false;
      clearTimeout(this.timerPhone);
      this.timerPhone = setTimeout(() => {
        if (!event.valid && this.user.phone != "+972") {
          this.phoneVerified = false;
          this.phoneError = true;
          this.phoneErrorMsg = "מספר הטלפון שגוי";
        } else if (event.valid) {
          this.phoneVerified = true;
          this.phoneError = false;
        }
      }, 100);
    },
    clearValidation(){

    },
    changePassword(e) {
      this.user.passwordConfirm = e;
    },
    encryptObject(data) {
      const key = CryptoJS.enc.Utf8.parse(process.env['MIX_APP_SECURE_KEY']);
      const iv = CryptoJS.lib.WordArray.random(16);
      const ivBase64 = CryptoJS.enc.Base64.stringify(iv);

      const objectToEncryptString = JSON.stringify(data);

      const encrypted = CryptoJS.AES.encrypt(objectToEncryptString, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
        keySize: 256 / 8,
      });

      const encryptedObject = {
        iv: ivBase64,
        value: encrypted.ciphertext.toString(CryptoJS.enc.Base64),
      };
      return encryptedObject;
    },
    async register() {
      let rand = (0 - 0.5 + Math.random() * (30 - 0 + 1)).toFixed();
      let newImage64 = icons[rand];
      let data = {
        referal_id: null,
        playlists_before_reg: 0,
        shootlists_before_reg: 0,
        indicators: null,
        name: this.user.name,
        surname: this.user.surname,
        phone: this.user.phone,
        phoneVerified: false,
        coupon: this.user.code.text,
        password: this.user.password,
        email: this.user.email,
        class: this.user.promocode.selected.letter,
        class_number: this.user.promocode.selected.number,
        image64: newImage64,
        track_data: null,
        users: this.user.users,
        usersData: this.user.usersData,
        google_id: null,
        facebook_id: null,
        apple_id: null
      };
      await axios.post('/admin/reg', data).then(() => {
        this.$notify({
          title: "Success",
          text: "User successfully added",
          type: "success",
          duration: 5000,
        });
      }).catch(err => {
        this.$notify({
          title: "Error",
          text: "Error while register",
          type: "error",
          duration: 5000,
        });
      })
    },
    validateEmail() {
      const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,30})+$/;
      const { email } = this.user;
      this.emailError = false;
      this.emailMsg = 'האימייל שגוי';
      
      if (regex.test(email)) {
        clearTimeout(this.timerEmail);
        this.timerEmail = setTimeout(() => {
          axios.post('/admin/checkEmailAdmin', { email: email })
            .then((res) => {
              let data = res.data;
              if (data.error) {
                this.emailMsg = 'משתמש עם דוא"ל זה כבר קיים';
                this.emailError = true;
                this.$notify({
                  title: 'שְׁגִיאָה',
                  text: 'משתמש עם דוא"ל זה כבר קיים',
                  type: 'error',
                  duration: 5000,
                });
              } else {
                this.emailError = false;
                this.emailVerified = true;
                this.emailMsg = "";
              }
            })
            .catch(() => {
              this.emailError = true;
              this.emailVerified = false;
            });
        }, 1000);
      } else {
        this.emailError = true;
        this.emailVerified = false;
      }
    },
    checkCoupon(e) {
      clearTimeout(this.timer);
      if (this.user.code.text == "") {
        this.couponError = false;
      }
      else {
        this.timer = setTimeout(() => {
          if (this.user.code.text.trim() !== "") {
            axios.post('/promo/validate', { coupon: this.user.code.text })
              .then((res) => {
                if (res.data.limit === res.data.used) {
                  this.$notify({
                    title: "Error",
                    text: "Error because of limits of the coupon",
                    type: "error",
                    duration: 5000,
                  });
                  this.couponError = true;
                } else {
                  this.couponError = false;
                }
              })
              .catch((err) => {
                this.$notify({
                  title: "Error",
                  text: "Error while checking the coupon",
                  type: "error",
                  duration: 5000,
                });
                this.couponError = true;
              });
          }
        }, 1000);
      }
    },
  },
  activated() {

  },
  async created() {

  },
};
</script>
  
<style lang="scss" scoped>
.style-one {
  border: 0;
  height: 1px;
  background: #333;
  background-image: linear-gradient(to right, #ccc, #333, #ccc);
}

.pagination {
  display: inline-block;
  padding-left: 0;
  margin: -10px 5px !important;
  border-radius: 4px;
}

.vue-tel-input ::v-deep .vti__dropdown {
  border: 1px solid white;
  background: white;
  border-radius: 4px;
  padding: 20px 10px 20px 13px;
  margin-right: 10px;
}

.vue-tel-input ::v-deep .vti__input {
  border: 1px solid white;
  background: white;
  border-radius: 4px;
  padding: 20px 20px 20px 27px;
  margin-right: 10px;
  width: 224px !important;
}

.vue-tel-input ::v-deep .vti__flag {
  scale: 1.2;
}

.vue-tel-input ::v-deep .vti__dropdown-arrow {
  margin-left: 10px;
}

.vue-tel-input {
  box-shadow: none;
}

.vue-tel-input {
  box-shadow: none;
}

.phone-alert {
  width: 300px;
    margin: auto;
    margin-top: 15px;
    margin-left: 0px;
    text-align: justify;
    display: flex;
    align-items: center;
  position: relative;
  font-family: "App";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  /* identical to box height */

  text-align: right;

  color: #000;

  svg {
    // position: absolute;
    // top: 61px;
    // right: 3px;
    margin: 0px 5px;
  }
}
</style>
  